import { CoreErrorDetails } from '../error-handler.backend-types'
import { TFunction } from 'i18next'

export function getBillNotFoundMessage(t: TFunction, details?: CoreErrorDetails<'BILL_NOT_FOUND'>): string | null {
  const message = t('pms.core_error.bill_not_found')
  return message
}
